import {
  Search,
  ShieldOff,
  Code,
  Globe,
  Palette,
  Layers,
  Database,
  KeyRound,
  type LucideIcon,
} from "lucide-react";
import { useTranslation } from "@/i18n/useTranslation";
import { Reveal } from "@/components/Reveal";
import type { TranslationKey } from "@/i18n/translations";

type Feat = { Icon: LucideIcon; t: TranslationKey; d: TranslationKey };

const items: Feat[] = [
  { Icon: Search, t: "features.f1.title", d: "features.f1.desc" },
  { Icon: ShieldOff, t: "features.f2.title", d: "features.f2.desc" },
  { Icon: Code, t: "features.f3.title", d: "features.f3.desc" },
  { Icon: Globe, t: "features.f4.title", d: "features.f4.desc" },
  { Icon: Palette, t: "features.f5.title", d: "features.f5.desc" },
  { Icon: Layers, t: "features.f6.title", d: "features.f6.desc" },
  { Icon: Database, t: "features.f7.title", d: "features.f7.desc" },
  { Icon: KeyRound, t: "features.f8.title", d: "features.f8.desc" },
];

export function Features() {
  const { t } = useTranslation();
  return (
    <section
      id="features"
      className="py-20 md:py-28 bg-white border-y border-border scroll-mt-16"
    >
      <div className="container mx-auto max-w-[1440px] px-5 md:px-6">
        {/* Asymmetric heading layout */}
        <div className="grid md:grid-cols-12 gap-6 md:gap-10 mb-14">
          <div className="md:col-span-6">
            <div className="text-xs font-semibold uppercase tracking-wider text-primary">
              {t("nav.features")}
            </div>
            <h2 className="mt-3 text-3xl md:text-4xl font-bold tracking-tight text-foreground">
              {t("features.title")}
            </h2>
          </div>
          <div className="md:col-span-6 md:pt-10">
            <p className="text-muted-foreground leading-relaxed text-[0.98rem]">
              {t("features.subtitle")}
            </p>
          </div>
        </div>

        {/* Clean grid — no boxes, just icon + text */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
          {items.map(({ Icon, t: tk, d: dk }, i) => (
            <Reveal key={i} delay={(i % 4) * 50}>
              <div className="text-primary">
                <Icon className="w-6 h-6" strokeWidth={1.75} />
              </div>
              <h3 className="mt-4 text-[0.95rem] font-semibold text-foreground">{t(tk)}</h3>
              <p className="mt-1.5 text-[0.85rem] text-muted-foreground leading-relaxed">
                {t(dk)}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
